import React from 'react';
import { Link } from 'react-router-dom';
import WhatsAppButton from '../WhatsAppButton/WhatsAppButton';
import { company, presentation, footerServices } from '../../data/siteContent';
import '../../styles/waves.css';
import './Footer.css';

/**
 * Composant Footer - Pied de page avec informations et bouton WhatsApp
 * Inclut les ondulations décoratives inspirées du logo
 */
function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      {/* Ondulations décoratives */}
      <div className="waves-footer">
        <svg className="waves-left" viewBox="0 0 200 100" preserveAspectRatio="none">
          <path
            className="wave wave-red"
            d="M0,50 Q50,30 100,50 T200,50"
            vectorEffect="non-scaling-stroke"
          />
          <path
            className="wave wave-orange"
            d="M0,60 Q50,40 100,60 T200,60"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
        <svg className="waves-right" viewBox="0 0 200 100" preserveAspectRatio="none">
          <path
            className="wave wave-blue"
            d="M0,50 Q50,30 100,50 T200,50"
            vectorEffect="non-scaling-stroke"
          />
          <path
            className="wave wave-purple"
            d="M0,60 Q50,40 100,60 T200,60"
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      </div>

      <div className="footer-container">
        <div className="footer-content">
          {/* Section Logo et Description */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/logo3.png" alt="Wote Logo" className="footer-logo-img" />
              <h3 className="footer-logo-text">Wote</h3>
            </div>
            <p className="footer-tagline">{company.tagline}</p>
            <p className="footer-description">
              {presentation.intro}
            </p>
          </div>

          {/* Section Services */}
          <div className="footer-section">
            <h4 className="footer-title">Nos Services</h4>
            <ul className="footer-links">
              {footerServices.map((service) => (
                <li key={service}>{service}</li>
              ))}
              <li>
                <Link to="/produits">Nos Produits</Link>
              </li>
            </ul>
          </div>

          {/* Section Contact */}
          <div className="footer-section">
            <h4 className="footer-title">Contact</h4>
            <div className="footer-contact">
              <WhatsAppButton />
            </div>
            <p className="footer-location">{company.location}</p>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Wote. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

